/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownGender } from '../models/db_DropdownGender';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class Genders {
    /**
     * Get a list of genders
     * @param programmes Programmes
     * @returns db_DropdownGender OK
     * @throws ApiError
     */
    public static listGenders(
        programmes?: string,
    ): CancelablePromise<Array<db_DropdownGender>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/genders',
            query: {
                'programmes': programmes,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
